/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SignatureLinkService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Creer un lien de signature pour un devis
     * Genere un lien public de signature electronique pour le devis, l'enregistre et notifie. Si un lien encore en attente existe deja pour ce devis, il est renvoye (200) au lieu d'en creer un second (201). 400 si le devis est deja signe.
     *
     * Reponse : `{ token, url, status, created_at }` — `url` est la page publique a transmettre au client.
     * @param idDevis
     * @returns any Retourner le lien existant
     * @throws ApiError
     */
    public signatureLinkCreateLink(
        idDevis: string,
    ): CancelablePromise<{
        token: string;
        url: string;
        status: string;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/devis/{id_devis}/signature/create-link',
            path: {
                'id_devis': idDevis,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Etat du lien de signature d'un devis
     * Le lien le plus recent du devis : `{ token, url, status, created_at }`, plus `signer { name, phone, signed_at }` une fois signe. Renvoie `null` (200) si aucun lien n'a jamais ete cree : ce n'est pas une erreur.
     * @param idDevis
     * @returns any
     * @throws ApiError
     */
    public signatureLinkGetStatus(
        idDevis: string,
    ): CancelablePromise<({
        token: string;
        url: string;
        status: string;
        created_at: string;
    } | null)> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/devis/{id_devis}/signature/status',
            path: {
                'id_devis': idDevis,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Revoquer les liens de signature d'un devis
     * Invalide tous les liens en attente du devis ; les pages publiques correspondantes refusent ensuite la signature. 404 `{ message }` s'il n'y a aucun lien actif. Reponse : `{ message, revoked_count }`.
     * @param idDevis
     * @returns any
     * @throws ApiError
     */
    public signatureLinkRevoke(
        idDevis: string,
    ): CancelablePromise<{
        message: string;
        revoked_count: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/devis/{id_devis}/signature/revoke',
            path: {
                'id_devis': idDevis,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Lister les liens de signature de l'entreprise
     * Du plus recent au plus ancien, filtrable par `status`. Chaque lien : `id`, `quote_id`, `token`, `url` (page publique de signature), `status`, `created_at`, et `signer { name, phone, signed_at }` une fois signe.
     * @returns string
     * @throws ApiError
     */
    public signatureLinkIndex(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/signature-links',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
